import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './PauseSubscriptionDialog.types';

export const renderPauseSubscriptionDialog = (data: Props) => openPopupHelper({ popupName: popupNames.PAUSE_SUBSCRIPTION, data });

export const closePauseSubscriptionDialog = () => closePopupHelper(popupNames.PAUSE_SUBSCRIPTION);
